import { Component, computed, effect, inject, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { RaIconComponent } from 'ra-ui';
import { parseChartValue } from '../../chart-options';
import { chartNumericCount } from '../../chart-render/chart-render';
import { ChartRenderService } from '../../chart-render/chart-render.service';

/**
 * Gráfico (item CHART) como ele imprime: o SVG que a API gravou no item. Usado onde o
 * gráfico só aparece (card do editor, lixeira, favoritos, link do documento).
 *
 * Sem SVG gravado (item ainda sem eco do servidor, ou criado antes do desenho existir), a
 * web desenha na hora com o mesmo código da API. Sem número nenhum, mostra o vazio.
 */
@Component({
    selector: 'chart-view',
    templateUrl: 'chart-view.component.html',
    styleUrl: 'chart-view.component.scss',
    imports: [RaIconComponent, TranslatePipe],
})
export class ChartViewComponent {
    /** `value` do item, como está no documento. */
    public value = input<unknown>();

    private _render = inject(ChartRenderService);

    private _chart = computed(() => parseChartValue(this.value()));

    public svg = computed(() => {
        const chart = this._chart();
        if (!chart) return null;
        return this._render.trust(chart.svg) ?? this._render.trust(this._render.render(chart));
    });

    public isEmpty = computed(() => {
        const chart = this._chart();
        return !chart || chartNumericCount(chart) === 0;
    });

    public label = computed(() => this._chart()?.title ?? '');

    constructor() {
        // Só baixa o ECharts se precisar desenhar aqui (sem SVG gravado).
        effect(() => {
            const chart = this._chart();
            if (chart && !chart.svg && chartNumericCount(chart) > 0) void this._render.load();
        });
    }
}
